// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"4be37739","709":"45b0e0bd"}[chunkId] + ".chunk.js";
};